import React, { Component } from 'react'
import propTypes from 'prop-types'
import {get, isEmpty} from 'lodash'
import { prefix } from 'helpers/component'
import BaseEditor from './baseEditor'
import Button from 'components/button'
import TextField from '@material-ui/core/TextField'
import {t} from "helpers/language"

require('./inlineEditor.scss')
const getClassName = prefix('inlineEditor-doubleStringEditor-')

class DoubleStringEditor extends Component {
  state = {
    value1: this.props.firstFieldProps.value,
    value2: this.props.secondFieldProps.value,
    errorText: '',
  }

  componentDidUpdate (prevProps) {
    if (this.props.open && !prevProps.open) {
      this.setState({ value1: this.props.firstFieldProps.value, value2: this.props.secondFieldProps.value, errorText: '' })
    }
  }

  onFocus = () => {
    document.execCommand('selectAll')
  }

  change = (field, value) => {
    this.setState({ [field]: value })
  }

  canCommit = () => {
    const {firstFieldProps, secondFieldProps} = this.props
    const {value1, value2} = this.state
    const isMandatory1 = get(firstFieldProps, 'isMandatory', false)
    const isMandatory2 = get(secondFieldProps, 'isMandatory', false)

    return (!isMandatory1 || !isEmpty(value1.trim())) && (!isMandatory2 || !isEmpty(value2.trim()))
  }

  getDefaultErrorText = () => {
    const {firstFieldProps, secondFieldProps} = this.props
    const {value1, value2} = this.state
    const isMandatory1 = get(firstFieldProps, 'isMandatory', false)
    const isMandatory2 = get(secondFieldProps, 'isMandatory', false)

    const isValue1Error = isMandatory1 && isEmpty(value1.trim())
    const isValue2Error = isMandatory2 && isEmpty(value2.trim())

    if (isValue1Error && isValue2Error)
      return `${firstFieldProps.label} and ${secondFieldProps.label} must be specified`

    return `${isValue1Error ? firstFieldProps.label : secondFieldProps.label} must be specified`
  }

  commit = () => {
    const {errorText} = this.props
    const {value1, value2} = this.state

    if (this.canCommit()) {
      this.props.onCommit({value1: value1.trim(), value2: value2.trim()})
    } else {
      this.setState({errorText: errorText ? errorText : this.getDefaultErrorText()})
    }
  }

  cancel = () => {
    this.props.onCancel()
  }

  keyDown = (e) => {
    switch (e.keyCode) {
      case 13:  // ENTER
        this.commit()
        break
      case 27:  // ESC
        this.cancel()
        break
    }
  }

  render () {
    const { open, anchor, firstFieldProps, secondFieldProps, width, commitLabel, cancelLabel, commitButtonWidth, cancelButtonWidth, ...otherProps } = this.props
    const { value1, value2, errorText } = this.state

    const fieldWidth = width / 2
    const editorWidth = width + commitButtonWidth + cancelButtonWidth + 12
    const maxLength1 = get(firstFieldProps, 'length')
    const maxLength2 = get(secondFieldProps, 'length')

    return (
      <BaseEditor open={open} anchor={anchor} {...otherProps} height={48} width={editorWidth} onClose={this.cancel} onFocus={this.focus}>
        <TextField placeholder={get(firstFieldProps, 'label')} value={value1 || ''} inputProps={{maxLength: maxLength1}} onChange={(e) => this.change('value1', e.target.value)} onKeyDown={this.keyDown} style={{width: fieldWidth}} autoFocus onFocus={this.onFocus} />
        <TextField placeholder={get(secondFieldProps, 'label')} value={value2 || ''} inputProps={{maxLength: maxLength2}} onChange={(e) => this.change('value2', e.target.value)} onKeyDown={this.keyDown} style={{width: fieldWidth}} />
        <div className={getClassName('buttons')}>
          <Button label={cancelLabel} flat width={cancelButtonWidth} onClick={this.cancel}/>
          <Button label={commitLabel} primary width={commitButtonWidth} onClick={this.commit} />
        </div>
        {errorText &&
          <div className={'errorText'}>
            {errorText}
          </div>
        }
      </BaseEditor>
    )
  }
}

DoubleStringEditor.propTypes = {
  firstFieldProps: propTypes.shape({
    value: propTypes.string,
    label: propTypes.oneOfType([
      propTypes.string,
      propTypes.object,
    ]),
    length: propTypes.number,
    isMandatory: propTypes.bool,
  }).isRequired,
  secondFieldProps: propTypes.shape({
    value: propTypes.oneOfType([
      propTypes.string,
      propTypes.object,
    ]),
    label: propTypes.oneOfType([
      propTypes.string,
      propTypes.object,
    ]),
    length: propTypes.number,
    isMandatory: propTypes.bool,
  }).isRequired,
  open: propTypes.bool.isRequired,
  anchor: propTypes.object,
  width: propTypes.number,
  errorText: propTypes.oneOfType([
    propTypes.string,
    propTypes.object,
  ]),
  commitLabel: propTypes.oneOfType([
    propTypes.string,
    propTypes.object,
  ]),
  cancelLabel: propTypes.string,
  commitButtonWidth: propTypes.number,
  cancelButtonWidth: propTypes.number,
  onCommit: propTypes.func.isRequired,
  onCancel: propTypes.func.isRequired,
}

DoubleStringEditor.defaultProps = {
  width: 300,
  commitLabel: t('Update'),
  cancelLabel: 'Cancel',
  commitButtonWidth: 90,
  cancelButtonWidth: 90,
}

export default DoubleStringEditor
